import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uuid from 'uuid/v4';
import { actions as reduxCustomerActions } from '../../customer/redux/customerActions';
import { actions as reduxProductActions } from '../redux/productActions';
import { actions as reduxChannelActions } from '../../channel/redux/channelActions';
import { actions as reduxPostcodeActions } from '../../../common/components/Postcode/redux/PostcodeActions';
import { actions as documentActions } from '../../productManagement/redux/DocumentReducer';
import { get, set, toInteger } from 'lodash';
import {
  authUserId,
  getOrganisationId,
  isBroker,
  isBrokerOrganisation,
} from '../../auth/redux/authActions';
import isString from '../../../helpers/socratesLodash/isString';
import { clearCustomerSearch } from '../../dashboard/containers/searchActions/storeCustomerSearch';

import { goToReview } from '../components/LeisureTravelForm/Components/TabContent/redux/ReviewTabActions';
import getIncludedResource from '../../../helpers/getIncludedResource';
import LeisureTravelForm from '../components/LeisureTravelForm/LeisureTravelForm';
import { getTravellerMedical } from '../helpers';

class LeisureTravelFormContainer extends Component {
  componentDidMount() {
    const { productActions } = this.props;
    productActions.getRegions();
  }

  componentWillUnmount() {
    const { dispatch, postcodeActions, productActions, customerActions } = this.props;
    productActions.clearData();
    customerActions.clearData();
    dispatch(clearCustomerSearch());
    postcodeActions.clearSelection();
    dispatch(goToReview(false)); // reset the flag set in Policy Upgrades
    documentActions.clearDocumentManagementData();
  }

  getNewInitialValues = (customer, product, source, brokerId, channelId, brokerType) => {
    const isBrokerType = brokerType === 'broker' || !brokerType;
    const isBrokerChannel = !channelId && brokerId && isBrokerType;
    // Adding answer to Medical Questions Object
    const medicalQuestions = get(
      product,
      'data.attributes.metadata.medical_declaration_questions',
      {},
    );

    const screeningProduct = get(product, 'data.attributes.metadata.screening', true);

    const currentCustomerAttributes = get(customer, 'data.attributes');
    const adults = [
      {
        title: get(currentCustomerAttributes, 'title', ''),
        first_name: get(currentCustomerAttributes, 'first_name', ''),
        last_name: get(currentCustomerAttributes, 'last_name', ''),
        dob: get(currentCustomerAttributes, 'dob', ''),
        email: get(currentCustomerAttributes, 'email', ''),
        age: '',
        phone1: get(currentCustomerAttributes, 'phone1', ''),
        phone2: get(currentCustomerAttributes, 'phone2', ''),
        marketing_options: get(currentCustomerAttributes, 'marketing_options', {
          post: -1,
          email: -1,
          sms: -1,
          phone: -1,
        }),
        conditions_covered: true,
        screening: '',
        screening_id: get(currentCustomerAttributes, 'screening_id', ''),
        sanction_id: get(currentCustomerAttributes, 'sanction_id', uuid()),
        sanctions_check: get(currentCustomerAttributes, 'sanctions_check', {}),
        address: {
          line1: get(currentCustomerAttributes, 'address.line1', ''),
          line2: get(currentCustomerAttributes, 'address.line2', ''),
          line3: get(currentCustomerAttributes, 'address.line3', ''),
          town: get(currentCustomerAttributes, 'address.town', ''),
          county: get(currentCustomerAttributes, 'address.county', ''),
          postcode: get(currentCustomerAttributes, 'address.postcode', ''),
        },
      },
    ];

    const subjectivities = get(product.data.attributes.metadata.subjectivities, []);
    const children = [];
    return {
      data: {
        current_tab: 1,
        mta: '',
        type: 'application',
        first_render: true,
        attributes: {
          quote_reference: '',
          quote_type: '',
          metadata: {
            communications: {
              email: !isBroker() && !isBrokerOrganisation(),
            },
            send_email: false,
            generate_documents: false,
            scheme_type: '',
            traveller_group: '',
            region: '',
            destinations: [],
            destinationsBackup: [],
            max_trip_duration: null,
            start_date: '',
            end_date: '',
            referred_activities: '',
            activities: '',
            occupations: '',
            adults,
            children: children,
            source: '',
            renewals_enabled: false,
            options: {
              winter_sports: false,
              golf_cover: false,
              business_equipment: false,
              cruise_cover: '',
              excess_waiver: false,
              exclude_cancellation: false,
              exclude_baggage: false,
              wedding_cover: false,
              hazardous_activities: 'A',
              end_supplier_failure: false,
              travel_dispute: false,
              smart_luggage: false,
            },
            storage: {
              quote_originator: get(this.props.auth.user, 'data.attributes'),
              quote_originator_organisation_id: getOrganisationId(),
            },
            subjectivities,
            screening_product: screeningProduct,
            medical_declaration_questions: medicalQuestions,
            overrides: null,
            fees: {},
            total_sanctions: 0,
            sanctions_check_complete: false,
            sales_channel: isBrokerChannel ? 'jtc-b2b' : '',
            // upgrade: 'Gold'
          },
        },
        relationships: {
          broker: {
            data: {
              id: brokerId,
            },
          },
          channel: {
            data: {
              id: channelId,
            },
          },
          source: {
            data: {
              ...source,
            },
          },
          schemes: {
            data: [],
          },
          user: {
            data: {
              id: authUserId(),
            },
          },
          customer: {
            data: {
              id: get(customer, 'data.id', ''),
            },
          },
          product: {
            data: {
              id: product.data.id,
            },
          },
        },
      },
    };
  };

  getApplicationInitialValues = (
    application,
    source,
    isInsuranceMarketingOptionsEnabled,
    renewalDeclarationText
  ) => {
    const { auth, clone, mta, productId } = this.props;
    if (!application) {
      return null;
    }
    const overrides = get(application, 'data.attributes.metadata.overrides');
    if (Array.isArray(overrides) && overrides.length === 0) {
      set(application, 'data.attributes.metadata.overrides', null);
    }

    if (isBroker() && !!source?.id) {
      set(application, 'data.relationships.source.data.id', source.id);
    }

    const leadTraveller = application?.data?.attributes?.metadata?.adults?.[0];
    // Reset any policy details if cloning
    if (application && clone) {
      set(application, 'data.id', null);
      set(application, 'data.attributes.metadata.options.travel_dispute', false);
      set(application, 'data.attributes.metadata.options.end_supplier_failure', false);
      set(application, 'data.attributes.metadata.options.smart_luggage', false);
      set(application, 'data.attributes.metadata.options.smart_luggage', false);
      set(application, 'data.attributes.policy_number', '');
      set(application, 'data.attributes.quote_reference', '');
      set(application, 'data.relationships.schemes.data', []);
      set(
        application,
        'data.attributes.metadata.storage.quote_originator',
        get(auth.user, 'data.attributes'),
      );
      set(application, 'data.relationships.product.data.id', productId);
    }

    if (application?.data?.attributes?.metadata?.send_sms && !leadTraveller?.phone2) {
      set(application, 'data.attributes.metadata.send_sms', false);
    }
    if (isInsuranceMarketingOptionsEnabled) {
      // convert empty array to object
      const additionalMarketing = leadTraveller?.metadata?.marketing_additional_info;
      if (Array.isArray(additionalMarketing) && additionalMarketing.length === 0) {
        set(
          application,
          'data.attributes.metadata.adults.[0].metadata.marketing_additional_info',
          {},
        );
      }
    }
    const channel = getIncludedResource(
      application.data,
      application.included,
      'channel',
    );

    if (!mta && get(application, 'data.relationships.schemes.data', []).length > 1) {

      if (get(channel, 'data.attributes.channel_type') === 'B2C') {
        set(application, 'data.relationships.schemes.data', []);
      }
    }

    if (get(application, 'data.attributes.metadata.options.cruise_cover') === 'false') {
      set(application, 'data.attributes.metadata.options.cruise_cover', false);
    }

    if (
      get(application, 'data.attributes.metadata.max_trip_duration') &&
      isString(application.data.attributes.metadata.max_trip_duration)
    ) {
      set(
        application,
        'data.attributes.metadata.max_trip_duration',
        toInteger(application.data.attributes.metadata.max_trip_duration),
      );
    }

    set(application, 'data.relationships.user.data', undefined);

    const cruiseCover = get(
      application,
      'data.attributes.metadata.options.cruise_cover',
      'cruise_not_set',
    );
    const cruiseCoverStorage = get(
      application,
      'data.attributes.metadata.storage.cruise_cover',
      'cruise_not_set',
    );
    if (cruiseCover === 'cruise_not_set' && cruiseCoverStorage !== 'cruise_not_set') {
      set(
        application,
        'data.attributes.metadata.options.cruise_cover',
        cruiseCoverStorage,
      );
    }
    const applicationStatus = get(application, 'data.attributes.status');

    const quoteOriginator =  application?.data?.attributes?.metadata?.storage?.quote_originator ?? [];


    const isRenewal = applicationStatus === 'renewal invited' || applicationStatus === 'renewal';
    if ( isRenewal
      && !application?.data?.attributes?.metadata?.renewal_declaration?.answer
      &&  quoteOriginator?.length < 1
    ) {
      // update quote originator on renewals to whomever first edits the quote
      set(
        application,
        'data.attributes.metadata.storage.quote_originator',
        get(auth.user, 'data.attributes'),
      );
    }
    const renewalDeclarationValues = application?.data?.attributes?.metadata?.renewal_declaration || {
      declaration: renewalDeclarationText?.replace('{{channel phone}}',channel?.data?.attributes?.metadata?.content?.telephone_number ?? ''),
      answer: ''
    };

    if (isRenewal) {
      set(application, 'data.attributes.metadata.renewal_declaration',renewalDeclarationValues);
    }



    const adults = application?.data?.attributes?.metadata?.adults;
    const children = application?.data?.attributes?.metadata?.children;

    const newAdults = getTravellerMedical(adults);
    const newChildren = getTravellerMedical(children);
    set(application, 'data.attributes.metadata.adults', newAdults);
    set(application, 'data.attributes.metadata.children', newChildren);

    return application;
  };

  render() {
    const {
      product,
      currentProduct,
      screening,
      application,
      mta,
      edit,
      isRenewal,
      customer,
      isExpired,
      policyId,
      source,
      brokerId,
      channelId,
      isMarketingEnabled,
      isInsuranceMarketingOptionsEnabled,
      isCarInsuranceMarketingEnabled,
      isHomeInsuranceMarketingEnabled,
      brokerType,
    } = this.props;

    if (!source && !mta) {
      return null;
    }

    const initialValues =
      this.getApplicationInitialValues(
        application,
        source,
        isInsuranceMarketingOptionsEnabled,
        currentProduct?.data?.attributes?.metadata?.renewal_declaration?.B2C
      ) ||
      this.getNewInitialValues(
        customer,
        currentProduct,
        source,
        brokerId,
        channelId,
        brokerType,
      );

    return (
      <LeisureTravelForm
        resource={initialValues}
        policyId={policyId}
        source={source}
        brokerId={brokerId}
        brokerType={brokerType}
        screening={screening}
        product={product}
        mta={mta}
        edit={edit}
        isRenewal={isRenewal}
        currentProduct={currentProduct}
        isExpired={isExpired}
        isMarketingEnabled={isMarketingEnabled}
        isInsuranceMarketingOptionsEnabled={isInsuranceMarketingOptionsEnabled}
        isCarInsuranceMarketingEnabled={isCarInsuranceMarketingEnabled}
        isHomeInsuranceMarketingEnabled={isHomeInsuranceMarketingEnabled}
      />
    );
  }
}

export default connect(
  (state) => ({
    product: state.product,
    screening: state.screening,
    searchData: state.customerSearch.searchedData,
    broker: state.broker,
    auth: state.auth,
  }),
  (dispatch) => ({
    channelActions: bindActionCreators(reduxChannelActions, dispatch),
    postcodeActions: bindActionCreators(reduxPostcodeActions, dispatch),
    productActions: bindActionCreators(reduxProductActions, dispatch),
    customerActions: bindActionCreators(reduxCustomerActions, dispatch),
    documentActions: bindActionCreators({ ...documentActions }, dispatch),
    dispatch,
  }),
)(LeisureTravelFormContainer);
